import React, { memo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import FloatingHeader from '../components/layout/FloatingHeader';
import Footer from '../components/Footer';
import PageMeta from '../components/PageMeta';
import { texte, PANELS } from '../components/startseite/texte';
import { starteAbschnitte } from '../components/startseite/abschnitte';
import StartAbschnitte from '../components/startseite/StartAbschnitte';
import Lichtszene from '../components/licht/Lichtszene';
import '../components/startseite/startseite.css';
import { SEITEN_BLENDE } from '../components/animations/seitenBlende';
import KaufHinweis from '../components/kauf/KaufHinweis';

// Werkzeuge-Seite (/shop) im neuen Design: dieselben Abschnitte wie die Startseite (Werkzeuge mit
// Filter und Suche, All-in-One, Kostenlos, Installer), nur ohne den großen Kopfbereich.
// Die alte Shop-Seite liegt im Git (Tag website-alt-2026-10-04).

// memo: die Bewegung setzt Klassen direkt am DOM, React soll sie nicht überschreiben
const Inhalt = memo(function Inhalt({ en }) {
  return <StartAbschnitte en={en} seite="shop" />;
});

export default function Shop() {
  const location = useLocation();
  const en = location.pathname === '/en' || location.pathname.startsWith('/en/');
  const wurzel = useRef(null);

  useEffect(() => {
    const T = texte(en);
    return starteAbschnitte({ wurzel: wurzel.current, T: T.szene, panels: PANELS, preise: T.preise });
  }, [en]);

  return (
    <motion.div {...SEITEN_BLENDE}>
      <PageMeta
        title={en ? 'Tools | DAVIDMEDIA' : 'Werkzeuge | DAVIDMEDIA'}
        description={en
          ? 'Extensions for After Effects: easing, bounce, shake, glitch, text, grids and more. One-time purchase or all of them in the All-in-One.'
          : 'Extensions für After Effects: Easing, Bounce, Shake, Glitch, Text, Raster und mehr. Einzeln als Einmalkauf oder alle zusammen im All-in-One.'}
        url={`https://www.davidmedia.de${en ? '/en' : ''}/shop`}
      />
      <FloatingHeader />
      {/* Rückkehr aus der Warenkorb-Kasse (?cart_success / ?cart_cancelled): Meldung, nach dem Kauf Korb leeren */}
      <KaufHinweis art="korb" en={en} />
      <div className="startseite" ref={wurzel}>
        <Lichtszene />
        <Inhalt en={en} />
      </div>
      <div className="relative z-10">
        <Footer />
      </div>
    </motion.div>
  );
}
